import { PickupStore } from '@lentau/address/shared/interfaces';

/**
 * Dom redirect only: currentStore может быть null, пока ТК нет в allStores,
 * хотя delivery/mode уже вернул userStores (alias / storeId).
 */
export function resolveDomPickupStoreFromUserStores(
  storeId: number | null | undefined,
  userStores: readonly PickupStore[] | null | undefined
): PickupStore | null {
  const stores: readonly PickupStore[] = userStores ?? [];

  if (storeId) {
    return stores.find((store: PickupStore) => store.id === storeId) ?? null;
  }

  return stores.find((store: PickupStore) => store.selected) ?? null;
}
